import { bookOutline } from "ionicons/icons";
import { ItemsTechno } from "./jobsDictionnary";

export const primItems: ItemsTechno[] = [
  {
    primary: true,
    hasChild: false,
    disabled: false,
    title: "Technologie",
    subtitle: "Cliquez ici pour accèder à la partie technologie",
    icon: "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/images-techno/pat-techno-3006.jpg",
    backgroundColor: "white",
  },
  {
    primary: true,
    hasChild: false,
    disabled: false,
    title: "Pratique",
    subtitle: "Cliquez ici pour accèder à la partie technologie",
    icon: "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/Images/Corbeille+-mains-UNE.jpg",
    backgroundColor: "white",
  },
  {
    primary: false,
    hasChild: true,
    secondary: true,
    disabled: false,
    title: "",
    subtitle: "",
    icon: "",
    size: "12",
    backgroundColor: "transparent",
    children: [
      {
        size: "6",
        primary: false,
        hasChild: false,
        secondary: true,
        disabled: false,
        title: "Livre de Technologie",
        subtitle: "Cliquez ici pour accèder au livre de technologie",
        icon: bookOutline,
        href: "book/?type=techno",
        backgroundColor: "rgba(var(--ion-color-primary-contrast-rgb), 1)",
      },
    ],
  },
  {
    primary: true,
    hasChild: false,
    disabled: false,
    title: "Mur Social",
    subtitle: "",
    icon: "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/Images/Mur+social+2.jpg",
    href: "feed",
    backgroundColor: "white",
  },
];

export const charItems: ItemsTechno[] = [
  {
    primary: true,
    hasChild: false,
    disabled: false,
    title: "Savoirs associés",
    subtitle: "Cliquez ici pour accèder à la partie technologie",
    icon: "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/Images/image-techno-formace(1)(1).jpg",
    backgroundColor: "white",
  },
  {
    primary: true,
    hasChild: false,
    disabled: false,
    title: "Pratique",
    subtitle: "Cliquez ici pour accèder à la partie technologie",
    icon: "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/Images/Lapin+saut%C3%A9+chasseur.00_04_15_11.Still002.jpg",
    backgroundColor: "white",
  },
  {
    primary: true,
    hasChild: false,
    disabled: false,
    title: "Livres de Technologie (T1 + T2)",
    subtitle: "Cliquez ici pour accèder à la partie technologie",
    icon: "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/Images/Capture+d%E2%80%99%C3%A9cran+du+2023-08-22+11-07-21.png",
    backgroundColor: "white",
  },
  {
    primary: true,
    hasChild: false,
    disabled: false,
    title: "Carnet de recette",
    subtitle: "Cliquez ici pour accèder à la partie technologie",
    icon: "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/Images/Capture+d%E2%80%99%C3%A9cran+du+2023-08-22+12-27-20.png",
    backgroundColor: "white",
    href: "formalpratique",
  },
  {
    primary: true,
    hasChild: false,
    disabled: false,
    title: "Sciences Appliquées",
    subtitle: "Cliquez ici pour accèder à la partie technologie",
    icon: "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/images-techno/Sciences-appliqu%C3%A9s-3006.png",
    href: "book/?type=sciencesappliquees",
    backgroundColor: "white",
  },
  {
    primary: true,
    hasChild: false,
    disabled: false,
    title: "PSE",
    subtitle: "Cliquez ici pour accèder à la partie technologie",
    icon: "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/Images/PSE.png",
    href: "book/?type=pse",
    backgroundColor: "white",
  },
  {
    primary: true,
    hasChild: false,
    disabled: false,
    title: "Mur Social",
    subtitle: "",
    icon: "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/Images/Mur+social+2.jpg",
    href: "feed",
    backgroundColor: "white",
  },
];

export const boulItems: ItemsTechno[] = [
  {
    primary: true,
    hasChild: false,
    disabled: false,
    title: "Savoirs associés",
    subtitle: "Cliquez ici pour accèder à la partie technologie",
    icon: "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/Images/image-techno-formace(1)(1).jpg",
    backgroundColor: "white",
  },
  {
    primary: true,
    hasChild: false,
    disabled: false,
    title: "Pratique",
    subtitle: "Cliquez ici pour accèder à la partie pratique",
    icon: "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/Images/BOUL-tuto.jpg",
    backgroundColor: "white",
  },
  {
    primary: false,
    hasChild: true,
    secondary: true,
    disabled: false,
    title: "",
    subtitle: "",
    icon: "",
    size: "12",
    backgroundColor: "transparent",
    children: [
      {
        size: "6",
        primary: false,
        hasChild: false,
        secondary: true,
        disabled: false,
        title: "Livre de Technologie",
        subtitle: "Cliquez ici pour accèder au livre de technologie",
        icon: bookOutline,
        href: "book/?type=techno",
        backgroundColor: "rgba(var(--ion-color-primary-contrast-rgb), 1)",
      },
      {
        size: "6",
        primary: false,
        hasChild: false,
        secondary: true,
        disabled: false,
        title: "Livre de Synthèse",
        subtitle: "Cliquez ici pour accèder au livre de technologie",
        icon: bookOutline,
        href: "book/?type=synthese",
        backgroundColor: "rgba(var(--ion-color-primary-contrast-rgb), 1)",
      },
      {
        size: "6",
        primary: false,
        hasChild: false,
        secondary: true,
        disabled: false,
        title: "Livre de Synthèse Corrigé",
        subtitle: "Cliquez ici pour accèder au livre de synthèse",
        icon: bookOutline,
        href: "book/?type=synthese-corrected",
        backgroundColor: "rgba(var(--ion-color-primary-contrast-rgb), 1)",
      },
      {
        primary: false,
        hasChild: false,
        secondary: true,
        disabled: true,
        title: "Livre de Gestion appliquée",
        subtitle: "Cliquez ici pour accèder au livre de technologie",
        icon: bookOutline,
        href: "book/?type=gestionsappliquees",
        backgroundColor: "rgba(170,170,170, 1)",
      },
      {
        primary: false,
        hasChild: false,
        secondary: true,
        disabled: false,
        title: "Livre de Sciences appliquées",
        subtitle: "Cliquez ici pour accèder au livre de synthèse",
        icon: bookOutline,
        href: "book/?type=sciencesappliquees",
        backgroundColor: "rgba(var(--ion-color-primary-contrast-rgb), 1)",
      },
    ],
  },
  {
    primary: true,
    hasChild: false,
    disabled: false,
    title: "PSE",
    subtitle: "Cliquez ici pour accèder à la partie technologie",
    icon: "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/Images/PSE.png",
    href: "book/?type=pse",
    backgroundColor: "white",
    size: "12",
  },

  {
    primary: true,
    hasChild: false,
    disabled: false,
    title: "Mur Social",
    subtitle: "",
    icon: "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/Images/Mur+social+2.jpg",
    href: "feed",
    backgroundColor: "white",
  },
];

export const patItems: ItemsTechno[] = [
  {
    primary: true,
    hasChild: false,
    disabled: false,
    title: "Technologie",
    subtitle: "Cliquez ici pour accèder à la partie technologie",
    icon: "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/images-techno/pat-techno-3006.jpg",
    backgroundColor: "white",
  },
  {
    primary: true,
    hasChild: false,
    disabled: false,
    title: "Pratique",
    subtitle: "Cliquez ici pour accèder à la partie pratique",
    icon: "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/Images/PAT-tuto.jpg",
    backgroundColor: "white",
  },
  {
    primary: false,
    hasChild: true,
    secondary: true,
    disabled: false,
    title: "",
    subtitle: "",
    icon: "",
    size: "12",
    backgroundColor: "transparent",
    children: [
      {
        primary: false,
        hasChild: false,
        secondary: true,
        disabled: false,
        title: "Livre de Synthèse",
        subtitle: "Cliquez ici pour accèder au livre de synthèse",
        icon: bookOutline,
        href: "book/?type=synthese",
        backgroundColor: "rgba(var(--ion-color-primary-contrast-rgb), 1)",
        size: "6",
      },
      {
        primary: false,
        hasChild: false,
        size: "12",
        secondary: true,
        disabled: false,
        title: "Livre de Synthèse Corrigé",
        subtitle: "Cliquez ici pour accèder au livre de technologie",
        icon: bookOutline,
        href: "book/?type=synthese-corrected",
        backgroundColor: "rgba(var(--ion-color-primary-contrast-rgb), 1)",
      },
      {
        primary: false,
        hasChild: false,
        size: "6",
        secondary: true,
        disabled: false,
        title: "Livre de Technologie",
        subtitle: "Cliquez ici pour accèder au livre de technologie",
        icon: bookOutline,
        href: "book/?type=techno",
        backgroundColor: "rgba(var(--ion-color-primary-contrast-rgb), 1)",
      },
    ],
  },
  {
    primary: true,
    hasChild: false,
    disabled: false,
    title: "PSE",
    subtitle: "Cliquez ici pour accèder à la partie technologie",
    icon: "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/images-techno/PSE-3006.png",
    href: "book/?type=pse",
    backgroundColor: "white",
    size: "12",
  },
  {
    primary: true,
    hasChild: false,
    disabled: false,
    title: "Mur social",
    subtitle: "",
    icon: "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/Images/Mur+social+2.jpg",
    href: "feed",
    backgroundColor: "white",
  },
];
